// extracted by mini-css-extract-plugin
module.exports = {"desc":"tools-module--desc--Arq_Y"};